export default "__VITE_ASSET__DKpn1j8D__"